import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

interface ClientBillingState {
  questionnaireResponse: QuestionnaireResponse | undefined;
  /** Caller-supplied sequence (e.g. timestamp); changes when billing/insurance intake is saved so the client profile panel can refetch Coverage/Observation. */
  insuranceLastUpdated: number;
}

const initialState: ClientBillingState = {
  questionnaireResponse: undefined,
  insuranceLastUpdated: 0,
};

const reducers = {
  updateQuestionnaireResponse: (
    state: ClientBillingState,
    action: PayloadAction<ClientBillingState["questionnaireResponse"]>,
  ) => {
    state.questionnaireResponse = action.payload;
  },
  setInsuranceLastUpdated: (state: ClientBillingState, action: PayloadAction<number>) => {
    state.insuranceLastUpdated = action.payload;
  },
};

const clientBillingSlice = createSlice({
  name: "clientBilling",
  initialState,
  reducers,
});

export const { updateQuestionnaireResponse, setInsuranceLastUpdated } = clientBillingSlice.actions;

/** Prefer this over `setInsuranceLastUpdated(Date.now())` at call sites so timestamps stay outside reducers but centralized here. */
export const touchInsuranceLastUpdated = () => setInsuranceLastUpdated(Date.now());

export const selectQuestionnaireResponse = (state: RootState) =>
  state.clientBilling.questionnaireResponse;

export const selectInsuranceLastUpdated = (state: RootState) =>
  state.clientBilling.insuranceLastUpdated;

export default clientBillingSlice.reducer;
